import React, { Fragment } from "react";

interface IButton {
  avancar?: boolean;
  previousStep: Function;
  avancarIcon?: boolean;
}

function Button({ avancar, previousStep, avancarIcon }: IButton) {
  return (
    <Fragment>
      <button
        className="btn btn--primary ml-2"
        onClick={() => (avancar ? () => {} : previousStep())}
        type={avancar ? "submit" : "button"}
      >
        {avancar || avancarIcon ? "AVANÇAR" : "VOLTAR"}
      </button>
    </Fragment>
  );
}
export default Button;
